import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "div1",
  style: {
    "height": "100%",
    "width": "100%",
    "position": "relative"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "300px",
      "border": "none",
      "background": "none",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "660px 0 0 960px"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.createXiaoqu())
  })]);
}